export const CONTRACT_LOADING_MESSAGE = 'Loading contracts and prices';
export const CONTRACT_TIMED_OUT_MESSAGE =
  'Unable to load contract prices. Visit the product page for details';
